// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Oe7W","delete":"styles_delete__FisTs","update":"styles_update__tAIQY","add":"styles_add__17LaT"};